import styled from 'styled-components'
import { softGray } from '../../styles/variables.js'

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 99999999;
`

const Modal = styled.div`
  background: ${({ gray }) => gray ? softGray : 'white'};
  border-radius: 6px;
  min-width: ${({ fullWidth }) => fullWidth ? '80vw' : '450px'};
  max-width: 80vw;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

const ModalContent = styled.div`
  padding: ${({ padding }) => padding ? padding : '40px 20px'};
  overflow-y: ${({ noScroll }) => noScroll ? 'hidden' : 'auto'};
  ${({ flexRow }) => flexRow ? `
    display: flex;
    flex-direction: row;
  ` : ''};

`

const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 20px 20px;
  & > button:first-child {
    margin-left: 0;
  }
`

export default {
  ModalOverlay,
  Modal,
  ModalContent,
  ModalFooter,
}
